/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * position object
 * @export
 * @interface GetUniverseConstellationsConstellationIdPosition
 */
export interface GetUniverseConstellationsConstellationIdPosition {
    /**
     * x number
     * @type {number}
     * @memberof GetUniverseConstellationsConstellationIdPosition
     */
    x: number;
    /**
     * y number
     * @type {number}
     * @memberof GetUniverseConstellationsConstellationIdPosition
     */
    y: number;
    /**
     * z number
     * @type {number}
     * @memberof GetUniverseConstellationsConstellationIdPosition
     */
    z: number;
}

/**
 * Check if a given object implements the GetUniverseConstellationsConstellationIdPosition interface.
 */
export function instanceOfGetUniverseConstellationsConstellationIdPosition(value: object): value is GetUniverseConstellationsConstellationIdPosition {
    if (!('x' in value) || value['x'] === undefined) return false;
    if (!('y' in value) || value['y'] === undefined) return false;
    if (!('z' in value) || value['z'] === undefined) return false;
    return true;
}

export function GetUniverseConstellationsConstellationIdPositionFromJSON(json: any): GetUniverseConstellationsConstellationIdPosition {
    return GetUniverseConstellationsConstellationIdPositionFromJSONTyped(json, false);
}

export function GetUniverseConstellationsConstellationIdPositionFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUniverseConstellationsConstellationIdPosition {
    if (json == null) {
        return json;
    }
    return {
        
        'x': json['x'],
        'y': json['y'],
        'z': json['z'],
    };
}

export function GetUniverseConstellationsConstellationIdPositionToJSON(json: any): GetUniverseConstellationsConstellationIdPosition {
    return GetUniverseConstellationsConstellationIdPositionToJSONTyped(json, false);
}

export function GetUniverseConstellationsConstellationIdPositionToJSONTyped(value?: GetUniverseConstellationsConstellationIdPosition | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'x': value['x'],
        'y': value['y'],
        'z': value['z'],
    };
}

